import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setselectedMouvement } from "../store/mouvementTypesSlice";
import { fetchSpecificSales,setSelectedSale, clearSelectedSale } from "../store/salesSlice";
import MyDialog from "../components/MyDialog";
import SaleOrder from "../components/dataDisplay/saleOrder";
import SaleForm from "../components/forms/SaleForm";

const useSaleDocument = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [orderMode, setOrderMode] = useState(false);

  const dispatch = useDispatch();

  const openSaleDocument = useCallback((mouvementType, sale = null, isOrder = false) => {
    
    dispatch(setselectedMouvement(mouvementType));
    setDialogTitle(mouvementType?.name || "Unknown");
    setOrderMode(isOrder);

    if (sale) {
      dispatch(setSelectedSale(sale));
    } else {
      //dispatch(clearSelectedSale());
    }

    setHasUnsavedChanges(false);
    setDialogOpen(true);
  }, [dispatch]);

  const closeSaleDocument = useCallback(() => {
    if (hasUnsavedChanges) {
      const confirmClose = window.confirm(
        "You have unsaved changes. Do you really want to close?"
      );
      if (!confirmClose) return;
    }
    setDialogOpen(false);
    dispatch(clearSelectedSale());
    setHasUnsavedChanges(false);
  }, [hasUnsavedChanges, dispatch]);

  // Render the Dialog inside the hook
  const SaleDialog = (
    <MyDialog
      open={dialogOpen}
      title={dialogTitle}
      onDiscard={closeSaleDocument}
      size="big"
    >
      {orderMode ? (
        <SaleOrder closeOrder={closeSaleDocument} />
      ) : (
        <SaleForm onClose={(isDirty) => setHasUnsavedChanges(isDirty)} />
      )}
    </MyDialog>
  );

  return {
    openSaleDocument,
    SaleDialog, // Return the Dialog component
  };
};

export default useSaleDocument;
